
import api from '../../../services/service_item'
import itemDetailView from '../../../components/pos/item_detail'

export default {
  components: {
    itemDetailView
  },
  data () {
    return {
      item_data: [],
      barcode: '',
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  methods: {
    scanBarcodeItem () {
      if (this.barcode !== '') {
        this.$store.commit('Loading')
        api.itemBarcode(this.REST_URL,
          this.header,
          {
            'barcode': this.barcode
          },
          result => {
            if (result.response === 'success') {
              if (result.data.id !== 0) {
                this.item_data = result.data
                // $('#itemDetailScan').modal('show')
                this.addItem(this.item_data)
              } else {
                this.$notification['warning']({
                  message: 'ดึงข้อมูลสินค้า',
                  description:
                    'ไม่มีข้อมูลสินค้า'
                })
                this.$refs.inputscan.focus()
              }
            } else {
              this.$notification['warning']({
                message: 'ดึงข้อมูลสินค้า',
                description:
                  result.message
              })
            }
            this.$store.commit('Loading')
          },
          error => {
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            this.$store.commit('Loading')
          }
        )
      }
    },
    addItem (obj) {
      let priceItem = obj.bar_data[0]
      // alert(priceItem.price_1 + '|' + priceItem.unit_code + '==' + JSON.stringify(this.$store.state.item_subs))
      var ch = this.$store.state.item_subs.findIndex(row =>
        // parseInt(row.price) === parseFloat(priceItem.price_1) &&
        // row.unit_code === priceItem.unit_code
        row.item_barcode === priceItem.barcode &&
        row.unit_code === priceItem.unit_code
      )
      if (ch > -1) {
        this.$store.state.item_subs[ch]['qty'] += parseFloat(1)
        this.$store.state.item_subs[ch]['total_amount'] = this.$store.state.item_subs[ch]['qty'] * this.$store.state.item_subs[ch]['price']
      } else {
        var data = {
          'name': obj.name,
          'unit_code': priceItem.unit_code,
          'item_barcode': priceItem.barcode,
          'qty': parseFloat(1),
          'price': parseFloat(priceItem.price_1),
          'normal_price': parseFloat(priceItem.price_1),
          'total_amount': parseFloat(priceItem.price_1 * 1),
          'item_data': obj
        }
        this.$store.state.item_subs.push(data)
      }
      this.$store.state.order_data.item_amount = 0
      this.$store.state.item_subs.forEach(val => {
        this.$store.state.order_data.item_amount += parseFloat(val['qty'] * val['price'])
      })
      $('#itemDetailScan').modal('hide')
      $('#itemDetail').modal('hide')
    }
  },
  mounted () {
    this.$refs.inputscan.focus()
    $('body').on('hidden.bs.modal', '.modal', function () {
      $(this).removeData('bs.modal')
      this.item_data = []
      this.barcode = ''
      this.$refs.inputscan.focus()
    }.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/scan.js